import type { GfxModel } from '@blocksuite/std/gfx';
import { z } from 'zod';

import type {
  BrushElementModel,
  ConnectorElementModel,
  GroupElementModel,
} from '../elements';

export type EmbedCardStyle =
  | 'horizontal'
  | 'horizontalThin'
  | 'list'
  | 'vertical'
  | 'cube'
  | 'cubeThick'
  | 'video'
  | 'figma'
  | 'html'
  | 'syncedDoc'
  | 'pdf'
  | 'citation'
  | 'audio';

export const LinkPreviewDataSchema = z.object({
  description: z.string().nullable(),
  icon: z.string().nullable(),
  image: z.string().nullable(),
  title: z.string().nullable(),
});

export type LinkPreviewData = z.infer<typeof LinkPreviewDataSchema>;

export type Connectable = Exclude<
  GfxModel,
  ConnectorElementModel | BrushElementModel | GroupElementModel
>;

export type BlockMeta = {
  'meta:createdAt'?: number;
  'meta:createdBy'?: string;
  'meta:updatedAt'?: number;
  'meta:updatedBy'?: string;
};

/**
 * Marks a block as one occurrence of a recurring series created by the
 * `/repeat` slash command. Every copy of the line — the source and each
 * journal occurrence — carries the same `id`, which is how `/delete-repeat`
 * finds the series from any one of its members.
 */
export type BlockRepeatMeta = {
  /** Series id, shared by every block in the series. */
  id: string;
  /** Canonical rule text, e.g. `every 3 days for 2 months`. */
  rule: string;
  /** `YYYY-MM-DD` the series was anchored to. */
  anchor: string;
};
